import styled from 'styled-components';
import { Media } from '../../../../styles/media';

const { tabletUp } = Media;

export const Container = styled.ul`
  display: grid;
  grid-gap: 16px;
  grid-auto-flow: column;
  width: fit-content;
  margin: 0;
  padding: 0;

  li {
    margin-right: 0;
  }
`;

export const SocialPadding = styled.div`
  padding: 40px 0;

  ${tabletUp`
    padding: 0;
    margin-left: auto;
  `};
`;
